import { Component } from '@theme/component';
  import { sectionRenderer } from '@theme/section-renderer';

  // Native facets update the URL; keep their rendered results aligned when Back/Forward changes it.
  class BHGCollection extends Component {
    #historyController;
    #metadataObserver;
    #drawerStartQuery = null;

    connectedCallback() {
      super.connectedCallback();
      this.#historyController?.abort();
      this.#historyController = new AbortController();
      window.addEventListener('popstate', this.#restoreResults, { signal: this.#historyController.signal });
      this.addEventListener('dialog:open', this.#handleDrawerOpen, { capture: true, signal: this.#historyController.signal });
      this.addEventListener('dialog:close', this.#handleDrawerClose, { capture: true, signal: this.#historyController.signal });
      // The native morph updates live attributes without reliably calling the live component hook.
      this.#metadataObserver?.disconnect();
      this.#metadataObserver = new MutationObserver(() => this.#syncMetadata());
      this.#metadataObserver.observe(this, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['data-canonical', 'data-refined', 'data-title'],
      });
      this.#syncMetadata();
    }

    updatedCallback() {
      super.updatedCallback();
      this.#syncMetadata();
    }

    disconnectedCallback() {
      this.#historyController?.abort();
      this.#metadataObserver?.disconnect();
      this.#drawerStartQuery = null;
      super.disconnectedCallback();
    }

    #handleDrawerOpen = (event) => {
      if (!(event.target instanceof Element) || event.target.id !== 'filters-drawer') return;
      this.#drawerStartQuery = window.location.search;
    };

    #handleDrawerClose = (event) => {
      if (!(event.target instanceof Element) || event.target.id !== 'filters-drawer') return;
      const changed = this.#drawerStartQuery !== null && this.#drawerStartQuery !== window.location.search;
      this.#drawerStartQuery = null;
      // DialogComponent has already restored its original scroll position before this event.
      if (changed) this.querySelector('#ResultsList')?.scrollIntoView({ block: 'start', behavior: 'instant' });
    };

    #syncMetadata() {
      const metadata = this.querySelector('[ref="metadata"]');
      if (!(metadata instanceof HTMLElement)) return;
      if (metadata.dataset.title) document.title = metadata.dataset.title;
      const canonical = document.head.querySelector('link[rel="canonical"]');
      if (canonical && metadata.dataset.canonical) canonical.setAttribute('href', metadata.dataset.canonical);
      const socialURL = document.head.querySelector('meta[property="og:url"]');
      if (socialURL && metadata.dataset.canonical) socialURL.setAttribute('content', metadata.dataset.canonical);
      let robots = document.head.querySelector('meta[data-bhg-collection-robots]');
      if (metadata.dataset.refined === 'true') {
        if (!robots) {
          robots = document.createElement('meta');
          robots.setAttribute('name', 'robots');
          robots.setAttribute('data-bhg-collection-robots', '');
          document.head.append(robots);
        }
        robots.setAttribute('content', 'noindex,follow');
      } else {
        robots?.remove();
      }
    }

    #restoreResults = async () => {
      const sectionId = this.dataset.sectionId;
      if (!sectionId) return;
      try {
        await sectionRenderer.renderSection(sectionId);
      } catch {
        window.location.reload();
      }
    };
  }

  if (!customElements.get('bhg-collection')) customElements.define('bhg-collection', BHGCollection);
